import React from 'react';
import { useTranslation } from 'react-i18next';
import { Moment } from 'moment';

// MUI
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/material';

// MUI Icons
import AssessmentIcon from '@mui/icons-material/Assessment';
import PublicIcon from '@mui/icons-material/Public';
import PublicOffIcon from '@mui/icons-material/PublicOff';

// Custom components
import FormHeadingID from './FormHeadingID';
import FormHeadingDate from './FormHeadingDate';
import { sifrarnici } from '@/lib/sifrarnici';

// Types
import { DCRecord } from '@/@types/lib/dataController';

type FormHeadingIzletDataProps = {
  record: DCRecord;
  disableStatus?: boolean;
};

function FormHeadingIzletData(props: FormHeadingIzletDataProps) {
  const { t } = useTranslation();

  const { record, disableStatus } = props;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { id, prvi_dan, status_id, is_otkazan, is_javno } = record;

  const divStyle = {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 10,
  };

  const iconStyle: SxProps = {
    ml: 1,
    mr: '4px',
  };

  const typographyVariant = 'subtitle2';

  const getVisibility = () => {
    if (status_id === sifrarnici.status_izleta.approved) {
        return t(is_javno ? 'hps.izlet_statusi_desc.visible' : 'hps.izlet_statusi_desc.hidden');
    }
    return ''
  }

  const getStatus = () => {
    if (disableStatus) {
      return undefined;
    }
    if (is_otkazan) {
      return t('hps.izlet_statusi_desc.otkazan');
    }
    if (status_id === sifrarnici.status_izleta.approved) {
      return t('hps.izlet_statusi_desc.approved');
    }
    if (status_id === sifrarnici.status_izleta.submitted) {
      return t('hps.izlet_statusi_desc.submitted');
    }
    if (status_id === sifrarnici.status_izleta.draft) {
      return t('hps.izlet_statusi_desc.draft');
    }
    return undefined;
  };

  const status = getStatus();
  const visibility = getVisibility();

  return (
    <Stack direction="row">
      <FormHeadingID id={id as number} />
      <FormHeadingDate date={prvi_dan as Moment} />
      {status ? (
        <Tooltip title={t('common.status') as string}>
          <div style={divStyle}>
            <AssessmentIcon sx={iconStyle} />
            <Typography align="left" variant={typographyVariant} className="nodrag">
              {status}
            </Typography>
          </div>
        </Tooltip>
      ) : null}
      {status_id === sifrarnici.status_izleta.approved ? (
        <Tooltip title={t('hps.izleti.tooltips.public_visibility') as string}>
          <div style={divStyle}>
            {is_javno ? <PublicIcon sx={iconStyle} /> : <PublicOffIcon sx={iconStyle} />}
            <Typography align="left" variant={typographyVariant} className="nodrag">
              {visibility}
            </Typography>
          </div>
        </Tooltip>
      ) : null}
    </Stack>
  );
}

export default FormHeadingIzletData;
